import type { TestGroupingItem } from '@vedalib/editor/lib/elements'
import { FileUsageTypeEnum } from '@vedalib/editor/lib/files'
import { isEmptyRtValue } from '@vedalib/rich-text'
import { useContext } from 'use-context-selector'

import { getObjectFitDivMap } from 'components/Editor/EditorElements/utils/getObjectFitDivMap'
import { RichTextViewer } from 'components/form/RichText/RichTextViewer'
import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'
import { t } from 'services/Translation'
import { useUrlByUsage } from 'utils/files'

import TestGroupingContext from '../../TestGroupingContext'
import { getNavPositionStyle } from '../../helper'
import * as s from './PdfView.module.scss'

interface IPdfAnswerCardProps {
  item: TestGroupingItem
  index: number
  total: number
}

const PdfAnswerCard = ({ item, index, total }: IPdfAnswerCardProps) => {
  const { styles, font } = useContext(TestGroupingContext)
  const imageUrl = useUrlByUsage(item.image, FileUsageTypeEnum.image)
  const hasImage = !!item.image?.id
  const backgroundImage = hasImage ? `url(${imageUrl})` : undefined
  const hasLabel = item.label && !isEmptyRtValue(item.label)
  const showPlaceholder = !hasLabel && !hasImage
  const dragIconBg = styles.dragButton.backgroundImage

  return (
    <div
      aria-label={item.image?.accessibility}
      className={s.card}
      style={{
        ...styles.common,
        ...styles.answer,
        backgroundImage,
        backgroundSize: getObjectFitDivMap(item.image?.objectFit),
      }}
    >
      <div
        className={s.mask}
        style={{
          backgroundColor: item.overlay || undefined,
          borderRadius: styles.common.borderRadius,
        }}
      />
      <div
        className={s.label}
        style={{
          justifyContent: styles.answer.alignItems,
        }}
      >
        <div className={s.textInner} style={font?.base}>
          {showPlaceholder ? (
            t('elements.testGrouping.answer.placeholder')
          ) : (
            <RichTextViewer styles={font} value={item.label} />
          )}
        </div>
      </div>
      <div
        className={s.iconWrapper}
        style={getNavPositionStyle(styles.dragButton?.iconsAlign, styles.indents?.padding)}
      >
        <div
          className={s.dragIcon}
          style={{
            width: styles.dragButton.width,
            height: styles.dragButton.height,
            color: styles.dragButton.color,
            backgroundColor: styles.dragButton.backgroundColor,
            backgroundImage: styles.dragButton.backgroundImage,
          }}
        >
          {!dragIconBg && <Icon name='builderDrug' size={KitSize.S} />}
        </div>
      </div>
      <div
        className={s.navigation}
        style={getNavPositionStyle(styles.answerNavigation?.iconsAlign, styles.indents?.padding)}
      >
        <div className={s.counter} style={font?.answerNumbering}>
          {index}/{total}
        </div>
      </div>
    </div>
  )
}

export default PdfAnswerCard
